import {Box, CheckBox, Flex, P, Span} from 'exsportia-components'
import {TextType} from 'exsportia-components/dist/types'
import {FC, ReactNode} from 'react'

import {safeRound} from '../../helpers/logic'
import {TranslatorScope} from '../../locale/types'
import {GradientLoader} from '../../ui/components/gradient-loader/gradient-loader'
import {useLocale} from '../../utils/i18n'

export type PriceRowProps = {
  id?: string
  text: ReactNode | TextType
  bold?: boolean
  hint?: TextType
  price: number
  count?: number
  subLine?: boolean
  checked?: boolean
  isLoading?: boolean
  subtext?: ReactNode | TextType
  currency?: TextType
  withCheck?: boolean
  isDisabled?: boolean
  isNegative?: boolean
  accent?: boolean
  secondaryItems?: boolean,
  onCheckChange?: () => void
}

export const PriceRow: FC<PriceRowProps> = ({
  id,
  text,
  hint,
  price,
  count,
  subtext,
  checked,
  currency,
  bold = false,
  subLine = false,
  isLoading = false,
  isDisabled = false,
  isNegative = false,
  accent = false,
  secondaryItems = false,
  withCheck = false,
  onCheckChange = () => null,
}) => {
  const {l} = useLocale()
  // Money is rounded at the point it is DISPLAYED, once, for every row in the booking flow
  // (WBA-856). A percentage subscription discount off a price with decimals lands on a float —
  // 43.7 less 37% is 27.529999999999998 — and this component interpolated the number raw, so the
  // participants step and the summary showed a customer a price with fifteen decimal places.
  // safeRound keeps two at most and drops trailing zeros, which is how every other price reads.
  const shownPrice = safeRound(Number(price) || 0)
  // const {data: venueData} = useQuery() // TODO: DO NOT REQUEST VENUE DATA HERE , IT'S BROKEN, PASS CURRENCY AS PROP

  return (
    <Box width='100%'>
      <Flex justifyContent='space-between' pr={subLine ? '32px' : '0px'}>
        <Box width='90%'>
          <P
            mr={'8px'}
          >
            {Boolean(count) && (
              <>
                <Span fontWeigt={'bold'}>{count}</Span>
                <Span
                  mx={'4px'}
                  color={'text-secondary'}
                >
                  {'×'}
                </Span>
              </>
            )}
            <Span
              fontWeight={bold ? '600' : 'unset'}
              color={accent ? 'primary' : secondaryItems ? 'text-secondary' : 'text-default'}
            >
              {text}
            </Span>
            {hint && (
              <>
                <Span>{', '}</Span>
                <Span color={'text-secondary'}>{hint}</Span>
              </>
            )}
          </P>
          {subtext && (
            <Box mt='4px'>
              <P color={'text-secondary'}>{subtext}</P>
            </Box>
          )}
        </Box>
        {
          isLoading ? (
            <GradientLoader height='24px' width='80px' />
          ) : (
            <Flex gap='8px' alignItems='center'>
              <P
                fontWeight={bold ? '600' : 'unset'}
                textAlign={'right'}
                whiteSpace='nowrap'
                color={accent ? 'primary' : undefined}
              >
                {isNegative && '-'}{currency ? l(`${currency}_symbolic` as TranslatorScope, {value: shownPrice}) : shownPrice}
              </P>
              {withCheck && (
                <CheckBox value={checked} id={id} onChange={onCheckChange} disabled={isDisabled} />
              )}
            </Flex>
          )
        }
      </Flex>
    </Box>
  )
}
